import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const LocationPicker = ({ formData, errors, onChange, suggestions, showSuggestions, onLocationSearch, onSelectLocation }) => {
  const [showMap, setShowMap] = useState(false);
  
  const popularLocations = [
    { name: "Bebek Koyu, İstanbul", lat: 41.0766, lng: 29.0433 },
    { name: "Alaçatı, İzmir", lat: 38.2667, lng: 26.3667 },
    { name: "Kaş, Antalya", lat: 36.2019, lng: 29.6411 },
    { name: "Bodrum, Muğla", lat: 37.0344, lng: 27.4305 },
    { name: "Çeşme, İzmir", lat: 38.3231, lng: 26.3025 }
  ];
  
  const handleLocationSelect = (location) => {
    onChange({ target: { name: 'location', value: location?.name } });
    onChange({ target: { name: 'latitude', value: location?.lat?.toString() } });
    onChange({ target: { name: 'longitude', value: location?.lng?.toString() } });
  };
  
  return (
    <div className="bg-card rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 shadow-organic">
      <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-4 md:mb-5 lg:mb-6">
        Konum Bilgileri
      </h2>
      <div className="space-y-4 md:space-y-5 lg:space-y-6">
        <div className="relative">
          <Input
            label="Etkinlik Konumu"
            type="text"
            name="location"
            placeholder="Konum aramaya başlayın (Örn: Caddebostan)"
            value={formData?.location}
            onChange={onLocationSearch}
            error={errors?.location}
            required
            autoComplete="off"
            description="Yazmaya başladığınızda öneriler görünecektir"
          />
          
          {showSuggestions && suggestions?.length > 0 && (
            <ul className="absolute z-50 w-full bg-white border border-gray-200 rounded-lg shadow-xl mt-1 max-h-60 overflow-y-auto">
              {suggestions?.map((item) => (
                <li
                  key={item?.place_id}
                  onClick={() => onSelectLocation(item)}
                  className="px-4 py-3 hover:bg-indigo-50 cursor-pointer text-sm border-b last:border-b-0 transition-colors text-gray-700"
                >
                  {item?.display_name}
                </li>
              ))}
            </ul>
          )}
        </div>
        
        <div>
          <label className="block text-sm md:text-base font-medium text-foreground mb-2 md:mb-3">
            Popüler Konumlar
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-3">
            {popularLocations?.map((loc) => (
              <button
                key={loc?.name}
                type="button"
                onClick={() => handleLocationSelect(loc)}
                className="flex items-center gap-2 px-3 md:px-4 py-2 md:py-3 text-sm md:text-base text-left bg-muted hover:bg-muted/80 rounded-lg transition-smooth"
              >
                <Icon name="MapPin" size={16} className="text-primary flex-shrink-0" />
                <span className="truncate">{loc?.name}</span>
              </button>
            ))}
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 lg:gap-6">
          <Input
            label="Enlem (Latitude)"
            type="number"
            name="latitude"
            placeholder="41.0766"
            value={formData?.latitude}
            onChange={onChange}
            error={errors?.latitude}
            step="0.0001"
          />
          
          <Input
            label="Boylam (Longitude)"
            type="number"
            name="longitude"
            placeholder="29.0433"
            value={formData?.longitude}
            onChange={onChange}
            error={errors?.longitude}
            step="0.0001"
          />
        </div>
        
        <div>
          <button
            type="button"
            onClick={() => setShowMap(!showMap)}
            className="flex items-center gap-2 px-4 py-2 text-sm md:text-base font-medium text-primary bg-primary/10 hover:bg-primary/20 rounded-lg transition-smooth"
          >
            <Icon name={showMap ? "ChevronUp" : "Map"} size={18} />
            {showMap ? "Haritayı Gizle" : "Haritada Göster"}
          </button>
        </div>
        
        {showMap && formData?.latitude && formData?.longitude && (
          <div className="w-full h-64 md:h-80 lg:h-96 rounded-lg md:rounded-xl overflow-hidden border border-border">
            <iframe
              width="100%"
              height="100%"
              loading="lazy"
              title={formData?.location || "Etkinlik Konumu"}
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps?q=${formData?.latitude},${formData?.longitude}&z=14&output=embed`}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationPicker;